import { useLingui } from '@lingui/react/macro'

import * as Form from '@/features/form'
import { FileUpload, PRESETS } from '@/features/files'
import Title from './Title'
import InputTile from './InputTile'

export default function HotelImage() {
  const { t } = useLingui()

  return (
    <InputTile>
      <Title
        title={t`Hotel Images`}
        description={t({
          comment:
            'Description to let the user know what we are using hotel images for. Which are used as preview and to show to the guest at the correct day times.',
          message: `Your hotel images, these are shown to the guest on his personal page as well as the preview when guests share the App with each other. Furthermore can you upload a Day and night image, which are shown to the user at the correct time of day.`
        })}
      />
      <div className="w-full overflow-x-auto">
        <div className="flex flex-row gap-4 p-2">
          <div>
            <Form.Field name="dayImage">
              {({ renderProps: { onChange, ...props } }) => (
                <FileUpload
                  className="max-h-48 w-48"
                  objectFit="cover"
                  accept="image/*"
                  onChange={onChange}
                  onRemove={() => onChange(null)}
                  placeholder={t`Choose a day hotel image`}
                  crop={{
                    aspectRatio: 1,
                    allowPadding: true,
                    shape: 'rect'
                  }}
                  imageResize={PRESETS.DEFAULT}
                  {...props}
                />
              )}
            </Form.Field>
          </div>
          <div>
            <Form.Field name="nightImage">
              {({ renderProps: { onChange, ...props } }) => (
                <FileUpload
                  className="max-h-48 w-48"
                  objectFit="cover"
                  accept="image/*"
                  onChange={onChange}
                  onRemove={() => onChange(null)}
                  placeholder={t`Choose a night hotel image`}
                  crop={{
                    aspectRatio: 1,
                    allowPadding: true,
                    shape: 'rect'
                  }}
                  imageResize={PRESETS.DEFAULT}
                  {...props}
                />
              )}
            </Form.Field>
          </div>
        </div>
      </div>
    </InputTile>
  )
}
